import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "cnpj",
	standalone: true
})
export class CnpjPipe implements PipeTransform {
	transform(unformattedCnpj: string): string {
		const regularExpression = new RegExp(
			/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/
		);
		const mask = "$1.$2.$3/$4-$5";
		return unformattedCnpj.replace(regularExpression, mask);
	}
}
